import React from "react";
import { BlogSec } from "./blog";

export const Blog = () => {
  return (
    <React.Fragment>
      <div className="blog-main">
        <BlogSec />
      </div>
    </React.Fragment>
  );
};
